import { useCallback, useContext } from 'react';
import context from '.';

const useShipping = () => {
  const { state, setState } = useContext(context);

  const setShipping = useCallback((stateOrFn) => {
    setState(ps => ({
      ...ps,
      shipping: typeof stateOrFn === 'function'
        ? stateOrFn(ps.shipping)
        : stateOrFn,
    }));
  });

  return [state.shipping, setShipping];
}

export default useShipping;